// these mirror values in _constants.scss

export const PHONE_MAX = 667
export const TABLET_PORTRAIT_MAX = 930
